import { createDetailDialog } from 'dialogs/common'
import { dialogSizes } from 'dialogs'
import Form from 'pages/produceStyles/form'
import { api, actionCreators } from 'store/modules/produceStyles'

const metadata = {
  icon: 'clone',
  page: 'produceStyles',
  dialogSize: dialogSizes.MD
}
export default createDetailDialog({ metadata, api, actionCreators, Form })
